import React from 'react';
interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}
export function FormSection({
  title,
  children,
  className = ''
}: FormSectionProps) {
  return <div className={`space-y-3 ${className}`} data-id="element-6384" data-mp="2x9r56ilahd8r">
      <div className="flex items-center" data-id="element-6385" data-mp="2x8h7huicm72n">
        <div className="h-6 w-1 bg-teal-500 rounded-full mr-3" data-id="element-6386" data-mp="2t8ytzjsuwy9u"></div>
        <h3 className="text-sm font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" data-id="element-6387" data-mp="2tarx4p49h0d3">
          {title}
        </h3>
      </div>
      <div className="border border-gray-200 dark:border-gray-700 rounded-xl p-5 bg-white dark:bg-gray-800/50 shadow-sm" data-id="element-6388" data-mp="2jim216ipq2to">
        {children}
      </div>
    </div>;
}